/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandKey = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 7V3h2v2h2V3h2v2h1.126A4.002 4.002 0 0 1 21 6a4 4 0 0 1-7.874 1zm13-1a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm.062 5.797 3.417 2.562L16.442 21H6v1H2v-2h2v-6H2v-2h4v1.586L7.586 12h7.783l-2.042 3.062.35-.035zM6 19h9.558l3.963-4.36-.583-.437-4.616 2.77-5.222.522-.2-1.99 1.852-.185.88-1.32H8.414l-2 2H6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHandKey as HandKey };
